<template>
  <div class="w-full px-4">
    <div class="w-full mx-auto max-w-screen-3xl">
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
</script>
